import { Anchor, Breadcrumbs, Card, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import CatalogTriggerForm from '../../components/CatalogTriggers/CatalogTriggerForm';
import Spinner from '../../components/Spinner';

import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['catalogTrigger']}`;

const CatalogTriggersDetailPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();
  const location = useLocation();

  const [catalogTrigger, setCatalogTrigger] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const { accountId, domainId, catalogTriggerId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/catalogTriggers/${catalogTriggerId}`, {})
      .then(({ catalogTrigger }) => {
        if (!catalogTrigger) {
          navigate(`/accounts/${accountId}/domains/${domainId}/catalogTriggers`);
        }

        setCatalogTrigger(catalogTrigger);
      })
      .catch(setLoadError);
  }, [fetch, navigate, accountId, domainId, catalogTriggerId]);

  const update = (catalogTrigger) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/catalogTriggers/${catalogTriggerId}`, {
      method: 'PUT',
      body: JSON.stringify(catalogTrigger),
    })
      .then(() => {
        navigate(location.pathname.replace(`/catalogTriggers/${catalogTrigger.id}`, '/catalogTriggers'));
      })
      .catch(setUserError);
  };

  const del = (cb) => {
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/catalogTriggers/${catalogTrigger.id}`, {
      method: 'DELETE',
    })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        navigate(location.pathname.replace(`/catalogTriggers/${catalogTrigger.id}`, '/catalogTriggers'));
      })
      .catch(setLoadError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!catalogTrigger) {
    return <Spinner />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/catalogTriggers` },
    { title: 'Details' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | ${catalogTrigger.name} | Details`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <CatalogTriggerForm
              catalogTrigger={catalogTrigger}
              saveCatalogTrigger={(catalogTrigger) => update(catalogTrigger)}
              deleteCatalogTrigger={(cb) => del(cb)}
            />
          </Card>
        </Grid.Col>
      </Grid>
      {userError ? (
        <div style={{ textAlign: 'right' }}>
          <ErrorMessage message={userError.message} />
        </div>
      ) : null}
    </>
  );
};

export default CatalogTriggersDetailPage;
